import { cloneDeep } from 'lodash-es';
import { initialFilters } from './config';

export const state = () => ({
  locale: null,
  pusherConfiguration: null,
  isAppInitialized: false,
  hasReceivedStationIdentity: false,
  isRecoveringFromSafetyMode: false,
  stationTagIds: [],
  launcherstationTagIds: [], // this is only to display in games-index box (see DEV-1065)
  reviewingGameId: null,
  searchedGameIds: [],
  filteredGameIds: [],
  featuredGameIds: [],
  bookingTimes: null,
  isFiltersEnabled: false,
  isSearchEnabled: false,
  filters: cloneDeep(initialFilters),
  search: '',
  volumeBeforeIdle: null,
  previousRoute: {},
  currentBookingTimeId: null,
  loadings: {
    filteredGames: false,
    getGame: false,
    getTutorial: false,
    getStation: false,
    stationTags: false,
    locales: false,
    callingHelp: false,
    fetchTranslations: false,
    changeLocale: false,
    initAppLocale: false,
    initApp: false,
    stationVideos: false,
    updateStationVolume: false,
    launchingGame: false,
    themeParkGameId: false,
  },
  errors: {
    stationTags: false,
    initApp: false,
    safetyModeWithoutPersistedState: false,
  },
  panels: [],
  previousBooking: null,
  previousSession: null,
  previousImpulseTime: null,
  themeParkGameId: null,
  // this is the appState of the launcher app
  appState: {
    idle: false,
    overlay: false,
    runningId: null,
    runningType: null,
    type: null,
    game: null,
    preset: null,
    ownership: null,
    license: null,
  },
  desktopClientVersion: null,
});
